import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { initMetaPixel, trackPageView } from './utils/meta-pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-beige-50 font-sans text-dark selection:bg-gold-200 selection:text-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <Testimonials data-id="element-4" />
      <OfferSection data-id="element-5" />
      <PricingSection data-id="element-6" />
      <FAQ data-id="element-7" />
      <FinalCTA data-id="element-8" />
    </div>;
}